
import {
  Component,
  OnInit,
  NgZone,
  HostListener
} from "@angular/core";

import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup, FormBuilder } from "@angular/forms";
import { CustomHttp } from "../../../common/customHttp.service";
import { ApiUrl } from "../../../common/apiUrls";
import { MainAppComponent } from "../../../layout/layout.component";
import { TestRatingModel } from "../../../common/viewModels/Analysis/SampleModel";
import { SampleTypesEnum } from "../../../common/enumcontainer.enum";
import { RecommendationModal } from "../../../common/viewModels/GlobalRegistry/UnitsModel";
import "rxjs/add/operator/map";

@Component({
  selector: "approveferroresults",
  templateUrl: "./approveferroresults.component.html",
  styleUrls: ["./approveferroresults.component.scss"],
})
export class ApproveFerroResults implements OnInit {
  id: number;
  testRatings: TestRatingModel[];
  approveferroresults: FormGroup;
  isSubmitted: boolean = false;
  sample: any;
  sampleStatus: number;
  screenTitle: string;
  lstRecommendations: RecommendationModal[];
  lstRecommendations1: RecommendationModal[];
  lstRecommendations2: RecommendationModal[];
  ckeState: {
    [key: string]: {
      show: boolean;
      filtered: RecommendationModal[];
    };
  } = {
    Recommendation: {
      show: false,
      filtered: []
    },
    Recommendation2: {
      show: false,
      filtered: []
    }
  };

  quillConfig = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ color: [] }, { background: [] }]
    ]
  };

  constructor(
    public _router: Router,
    private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl,
    private _route: ActivatedRoute,
    private _mApp: MainAppComponent,
    private _toastrService: ToastrService,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.id = this._route.snapshot.params["id"];
    this.BindApprovedResult(this.id);
    this.BingTestGrades();
    this.GetSampleResultsBySampleId(this.id);
    this.GetSampleStatusBySampleId();
    this.approveferroresults = this._formBuilder.group({
      SampleId: [0],
      Recommendation: [""],
      Recommendation2: [""],
      FerroGraphyRatingId: [""]
    });
    this.GetRecommendationsMinInfoList();
  }

  GetSampleStatusBySampleId() {
    this._http
      .get(this._appUrl.GetSampleStatusBySampleId + this.id)
      .subscribe(
        (data) => {
          this.sampleStatus = data.json().Result;
          if (this.sampleStatus == 3) {
            this.screenTitle = "Approve Ferro Sample Results";
          }
          else {
            this.screenTitle = "View Ferro Sample Results";
          }
        },
        (error) => {
          this._toastrService.error(error.json().Result);
        }
      );
  }

  BindApprovedResult(id) {
    this._http
      .get(this._appUrl.ViewSampleReport + id + "&IsFromGeneral=" + false)
      .subscribe(
        (data) => {
          this.sample = data.json().Result.SampleDto;
          document.getElementById("dvHtmlContent").innerHTML =
            data.json().Result.htmlContent;
        },
        (error) => {
          this._toastrService.error(error.json().Result);
        }
      );
  }

  BingTestGrades() {
    this._http
      .get(this._appUrl.GetListOfTestRatings)
      .subscribe(
        (data) => {
          if (data.json().Result) {
            this.testRatings = data.json().Result;
          }
        },
        (error) => {
          this._toastrService.error(error.json().Result);
        }
      );
  }

  OnSubmit(IsSaveNext) {
    this.isSubmitted = true;
    if (this.approveferroresults.valid) {
      this._mApp.ShowLoader();
      let ferroResults = this.approveferroresults.value;
      ferroResults.IsSaveNext = IsSaveNext;
      ferroResults.SampleId =
        this._route.snapshot.params["id"];
      this._http
        .post(
          this._appUrl.UpsertFerroGraphyRecommendationsandRatings,
          ferroResults
        )
        .subscribe(
          (data) => {
            this._mApp.HideLoader();
            this._toastrService.success(data.json().Result);
            this._router.navigate(["/samplestatus"]);
          },
          (error) => {
            this._mApp.HideLoader();
            this._toastrService.error(error.json().Result);
          }
        );
    }
  }

  GetSampleResultsBySampleId(id) {
    this._mApp.ShowLoader();
    this._http
      .get(this._appUrl.GetFerroRecommendations + id)
      .subscribe(
        (data) => {
          this._mApp.HideLoader();
        if (data.json() != null && data.json() != undefined) {
          this.approveferroresults.setValue(data.json().Result);
          }
        },
        (error) => {
          this._mApp.HideLoader();
        }
      );
  }

  GetRecommendationsMinInfoList() {
    this._http
      .get(
        this._appUrl.GetRecommendationsMinInfoList +
        SampleTypesEnum.ferroGraphy
      )
      .subscribe(
        (data) => {
          if (data.json().Result != null) {
            this.lstRecommendations = data.json().Result;
             this.lstRecommendations1 = data.json().Result;
            this.lstRecommendations2 = data.json().Result;
          }
        },
        (error) => {
          this._toastrService.error(error.json().Result);
        }
      );
  }

  onEditorCreated(
    quill: any,
    controlName: string
  ) {

    quill.root.addEventListener(
      "focus",
      () => {

        this.ngZone.run(() => {
          this.filterQuillDropdown(controlName);
        });

      }
    );

    quill.root.addEventListener(
      "click",
      () => {

        this.ngZone.run(() => {
          this.filterQuillDropdown(controlName);
        });

      }
    );

  }

  onQuillChanged(
    event: any,
    controlName: string
  ) {

    this.ngZone.run(() => {
      this.filterQuillDropdown(controlName);
    });

  }

  filterQuillDropdown(controlName: string) {

    Object.keys(this.ckeState).forEach((key) => {

      if (key !== controlName) {
        this.ckeState[key].show = false;
      }

    });

    const state = this.ckeState[controlName];
    const control = this.approveferroresults.get(controlName);
    const value = control ? control.value : "";
    const text = this.stripHtml(value).trim();

    if (
      this.lstRecommendations &&
      this.lstRecommendations.length > 0
    ) {
      if (!text) {
        state.filtered =
          this.lstRecommendations.slice();
      }
      else {
        state.filtered =this.lstRecommendations.filter(x =>
              x.Recommendation &&
              x.Recommendation
                .toLowerCase()
                .indexOf(text.toLowerCase()) !== -1
          );
      }
      state.show = state.filtered.length > 0;
    }
    else {
      state.filtered = [];
      state.show = false;
    }
  }

  selectCkeRecommendation(
    item: RecommendationModal,
    controlName: string
  ): void {

    this.approveferroresults.patchValue({
      [controlName]: item.Recommendation
    });

    this.ckeState[controlName].show = false;
    this.ckeState[controlName].filtered = [];
  }

  private stripHtml(html: string): string {
    if (!html) {
      return "";
    }

    return html
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: any): void {
    this.ngZone.run(() => {
      const target = event.target;
      const clickedInsideEditor =
        target.closest(".ql-editor") ||
        target.closest(".ql-toolbar") ||
        target.closest(".cke-autocomplete-panel");
      if (!clickedInsideEditor) {
        Object.keys(this.ckeState)
          .forEach((key) => {
            this.ckeState[key].show = false;
          });
      }
    });
  }
}
